import React from 'react';
import { grid } from '@noths/polaris-client-ribbons-base';
import { SvgIcon } from '@noths/polaris-client-ribbons-design-system';

import { getIconPath } from 'src/utils';
import * as styles from './styles';

export interface Props {
  controls: string;
  isExpanded: boolean;
  toggleExpanded: () => void;
}

const CHEVRON_DOWN = getIconPath('icons-16-chevron-down.svg');
const CHEVRON_UP = getIconPath('icons-16-chevron-up.svg');

export const ExpandableToggleButton = ({ controls, isExpanded, toggleExpanded }: Props) => (
  <div>
    <button
      aria-controls={controls}
      aria-expanded={isExpanded}
      css={styles.expandingButton}
      onClick={toggleExpanded}
    >
      <SvgIcon
        height={16}
        width={16}
        color={`var(--brand-purple-base)`}
        src={isExpanded ? CHEVRON_UP : CHEVRON_DOWN}
      />
      &nbsp; Show {isExpanded ? 'less' : 'more'}
    </button>
    <div css={[grid, styles.expandingButtonDividerContainer]}>
      <hr css={styles.expandingButtonDivider} />
    </div>
  </div>
);
